module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"off":"Off","on":"On"},"de":{"off":"Aus","on":"Ein"},"fr":{"off":"Off","on":"On"},"it":{"off":"Off","on":"On"}}')
  delete Component.options._Ctor
}
